import { RetryIcon } from 'shared/ui/icons';

export const CustomToastWithRetry = ({ message, retryFn }) => {
  return (
    <div className="flex flex-col gap-2">
      <div>{message}</div>
      <button
        onClick={() => {
          retryFn();
        }}
        className="flex items-center gap-2 text-[#2E51CD] font-medium hover:text-[#6CA1F0] text-sm"
      >
        <RetryIcon width={14} height={14} /> Retry
      </button>
    </div>
  );
};
